import React, { useState } from 'react';
import { CalloutBox, CalloutBoxThemes } from 'ht-styleguide';
import styles from './hellotechnow.module.scss';

const HelloTechNowMessage = () => {
  const [visible, setVisible] = useState(false);
  const toggleMessage = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setVisible(!visible);
  };
  const callOutText =
    'We offer HelloTech Now! for services that can be performed by a tech remotely. You can get support right away and we&apos;re available. Not only is HelloTech Now! convenient, it saves you cash!';

  return (
    <div className={styles.message}>
      <div className={styles.messageTitle}>
        <a href="/" className="-no-decoration" onClick={toggleMessage}>
          What is HelloTech NOW?
        </a>
      </div>
      {visible ? <CalloutBox className="marginY-small2" theme={CalloutBoxThemes.DEFAULT} text={callOutText} /> : null}
    </div>
  );
};

export default HelloTechNowMessage;
